import { render, staticRenderFns } from "./ChoixList.vue?vue&type=template&id=77a30f28&"
import script from "./ChoixList.vue?vue&type=script&lang=js&"
export * from "./ChoixList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports